<template>
  <v-card>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab>Somatometría</v-tab>
      <v-tab>Rayos X</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <Somatometria />
      </v-tab-item>

      <v-tab-item>
        <RayosX />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Somatometria from '@/components/recepcion/Somatometria.vue'
import RayosX from '@/components/recepcion/RayosX.vue'

export default {
  name: 'RecepcionPacientes',
  components: {
    Somatometria,
    RayosX
  },
  data() {
    return {
      tab: 0
    }
  }
}
</script>
